import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'healthspark-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Health Spark',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8004592003,
  email: 'support@healthspark.net',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/healthspark/index.js